import React from 'react';
import DatosfijosPlayaModulosRollos from '../../components/datosfijos/PlayaModulosRollos';



const PlayaModulosRollos: React.FC = () => {
  return (
    <div style={{ padding: '20px', textAlign: 'center', alignItems: 'center', justifyContent: 'center' }}>
      <DatosfijosPlayaModulosRollos />


    </div>
  );
};

export default PlayaModulosRollos;